<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygId" label="仓库名称">
              {{ formData.ygCode || '' }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygDate" label="费用发生日期">
              {{ formData.ygDate || '' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="userName" label="费用发生人">
              {{ formData.userName || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="unitPrice" label="单价(元)">
              {{ formData.unitPrice || '0' }}
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygNumber" label="数量">
              {{ formData.ygNumber || '0' }}

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygUnitName" label="数量单位">
              {{ formData.ygUnitName || '' }}

            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="allPrice" label="总价(元)">
              {{ formData.allPrice || '0' }}

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="costType" label="费用类型">
              {{ costTypeListMap.get(formData.costType) || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="jxPrice" label="绩效">
              {{ formData.jxPrice || '' }}
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
import { costTypeList } from '@/utils/dict'

export default {
  name: 'OilTankCostDetail',

  data () {
    return {
      costTypeListMap: costTypeList,
      formData: {
        ygId: '',
        ygDate: '',
        userId: '',
        unitPrice: '',
        ygNumber: '',
        ygUnit: '',
        allPrice: '',
        costType: '',
        jxPrice: ''
      },

      loading: false

    }
  },
  created () {
    if (this.id) {
      this.loadData()
    }
  },
  computed: {
    id () {
      return this.$route.query.id
    }
  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.oilTankCost.selectYgCostById, {
          params: { id: this.id }
        })
        .then(res => {
          this.formData = res || {}
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
